import React from 'react';
import './BlogContentRenderer.scss';

function BlogContentRenderer({ section }) {
  const renderContent = () => {
    if (!section.content) return null;

    let contentHTML = section.content;

    if (section.links && Array.isArray(section.links)) {
      section.links.forEach(link => {
        const escapedText = link.text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escapedText})`, 'g');
        contentHTML = contentHTML.replace(
          regex,
          `<a href="${link.url}" target="_blank" rel="noopener noreferrer">$1</a>`
        );
      });
    }

    return contentHTML.split('\n\n').map((para, i) => (
      <p
        className="blog-content__text"
        key={i}
        dangerouslySetInnerHTML={{ __html: para }}
      />
    ));
  };

  switch (section.type) {
    case 'image':
      return (
        <div className="blog-content__block">
          <img className="blog-content__image" src={section.src} alt={section.alt || ''} />
          {renderContent()}
        </div>
      );

    case 'video':
      return (
        <div className="blog-content__block">
          <video controls>
            <source src={section.src} type="video/mp4" />
          </video>
          {renderContent()}
        </div>
      );

    case 'youtube':
      return (
        <div className="blog-content__block">
          <iframe
            width="100%"
            height="400"
            src={section.youtube}
            frameBorder="0"
            allowFullScreen
            title="YouTube Embed"
          />
          {renderContent()}
        </div>
      );

    case 'figma':
      return (
        <div className="blog-content__block">
          <iframe
            width="100%"
            height="500"
            src={section.url}
            allowFullScreen
            title="Figma Embed"
          />
          {renderContent()}
        </div>
      );

    default:
      return <>{renderContent()}</>;
  }
}

export default BlogContentRenderer;